if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      swiperRef = null;

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');

        this.querySelectorAll('.js-thumbnail-btn').forEach((thumbnailItem) => {
          thumbnailItem.addEventListener('click', () => {
            const linkTarget = thumbnailItem.href.split('#');

            if (linkTarget.length > 0) {
              var elementTop = document.getElementById('#' + linkTarget[1]);
              elementTop.scrollIntoView();
            }
          });
        });
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.querySelectorAll('.fieldset--sizes .variant-size').forEach((item) => {
          item.checked = false;
        });

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        this.swiperRef = new Swiper('.swiper', {
          // Optional parameters
          loop: true,
          pagination: true,
          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
          },

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          // And if we need scrollbar
          scrollbar: {
            el: '.swiper-scrollbar',
          },
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true, null);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          // reload <script defer id="sizebay-vfr-v4" src="https://static.sizebay.technology/886/prescript_new.js"></script>
          const sizebayScript = document.getElementById('sizebay-vfr-v4');
          if (sizebayScript) {
            sizebayScript.remove();
            const newScript = document.createElement('script');
            newScript.id = 'sizebay-vfr-v4';
            newScript.src = 'https://static.sizebay.technology/886/prescript_new.js';
            document.body.appendChild(newScript);
          }

          // reload <script id="szb-vfr__base" src="https://vfr-v3-production.sizebay.technology/V4/implantation/index.js"></script>
          const szbVfrBase = document.getElementById('szb-vfr__base');
          if (szbVfrBase) {
            szbVfrBase.remove();
            const newScript = document.createElement('script');
            newScript.id = 'szb-vfr__base';
            newScript.src = 'https://vfr-v3-production.sizebay.technology/V4/implantation/index.js';
            document.body.appendChild(newScript);
          }

          // custom:reloadSizeGuide
          const events = [
            'custom:reloadSizeGuide',
            'custom:reloadWishlistDrawer',
            'custom:reloadStoreAvailability',
            'custom:reloadReviewsDrawer'
          ]
          events.forEach((event) => {
            const customEvent = new CustomEvent(event);
            document.dispatchEvent(customEvent);
          });

        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            document.querySelector('.product__info-container').classList.add('rerendered');
            document.querySelector('.product-form__submit').classList.remove('select-first-btn');
            
            callback(html);

            // custom:reloadSizeGuide
            const events = [
              'custom:reloadSizeGuide',
              'custom:reloadWishlistDrawer',
              'custom:reloadStoreAvailability',
            ]
            events.forEach((event) => {
              const customEvent = new CustomEvent(event);
              document.dispatchEvent(customEvent);
            });
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        const selectedVariantInventory = JSON.parse(productInfoNode.querySelector('variant-selects [data-selected-variant-quantity]')?.innerHTML)

        const hasInventory = document.querySelector('.js-inventory');

        if (hasInventory) {
          if (selectedVariantInventory.quantity < 4 && selectedVariantInventory.quantity > 0) {
            hasInventory.classList.add('show');
          } else {
            hasInventory.classList.remove('show');
          }
        }


        const preOrderDetails = JSON.parse(
          productInfoNode.querySelector('[data-variants-preorder]')?.innerHTML || '{}'
        );
        const selectedVariantObject = !!selectedVariant ? JSON.parse(selectedVariant) : null;

          // custom:reloadSizeGuide
          const event = new CustomEvent('custom:reloadSizeGuide');
          document.dispatchEvent(event);

          const variantChangedEvent = new CustomEvent('variant:changed', {
            detail: { variant: selectedVariantObject }
          });
          document.dispatchEvent(variantChangedEvent);

        if (selectedVariantObject) {
          selectedVariantObject.isPreorder = preOrderDetails[selectedVariantObject.id] || false;
        }
        return selectedVariantObject;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id, variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');
          const preOrderText = this.querySelector('.js-preorder-text');

          const isSoldOut = !variant.available;
          const isPreorder = variant.isPreorder;

          let message = window.variantStrings.soldOut;
          if (!isSoldOut) {
            message = isPreorder ? window.variantStrings.preOrder : window.variantStrings.addToCart;
          }

          if (preOrderText !== null) {
            this.productForm?.querySelector('.js-preorder-text').classList.add('visible');
            document.getElementById('preorderinput').name = 'properties[_Preorder]';

            if (!isPreorder) {
              this.productForm?.querySelector('.js-preorder-text').classList.remove('visible');
              document.getElementById('preorderinput').name = 'empty';
            }
          }

          this.productForm?.toggleSubmitButton(isSoldOut, message);

          const notifyMe = document.getElementById('NotifyMe');

          if (html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') == true) {
            notifyMe ? document.getElementById('NotifyMe').classList.add('visible') : null;
          } else {
            notifyMe ? document.getElementById('NotifyMe').classList.remove('visible') : null;
          }

          document.querySelectorAll('.swiper-wrapper .target-thumbnail').forEach((mediaList, index) => {
            if (mediaList.dataset.color == variant.option1) {
              // this.swiperRef?.slideTo(index);
              return false;
            }
          });

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId, variant) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));

        const thumbnailGallerySource = this.querySelector('media-gallery .thumbnail-list');

        var thumbnailGallerySourceItems = thumbnailGallerySource?.querySelectorAll('.thumbnail-list__item')
          ? Array.from(thumbnailGallerySource?.querySelectorAll('.thumbnail-list__item'))
          : [];

        // mediaGallerySourceItems.forEach((mediaImg) => {
        //   if (mediaImg.dataset.color == variant?.featured_media?.alt) {
        //     mediaImg.style.display = 'block';
        //     console.log('block')
        //   } else {
        //     mediaImg.style.display = 'none';
        //   }
        // });

        // handle thumbnail display
        // thumbnailGallerySourceItems.forEach((mediaImg) => {
        //   if (mediaImg.dataset.color == variant?.featured_media?.alt) {
        //     mediaImg.style.display = 'block';
        //   } else {
        //     mediaImg.style.display = 'none';
        //   }
        // });

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
